export default {
  "smart": [],
  "measure": [],
  "standart": [],
}
